export enum SortOption {
  AcquisitionTime = 'AcquisitionTime',
  CashDue = 'CashDue',
  FreeShipping = 'FreeShipping',
  HighestPrice = 'HighestPrice',
  LowestMileage = 'LowestMileage',
  LowestPrice = 'LowestPrice',
  MonthlyPayment = 'MonthlyPayment',
  MostPopular = 'MostPopular',
  NewestInventory = 'NewestInventory',
  NewestYear = 'NewestYear'
}

export default SortOption;
